import { Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';

// project-imports
import Avatar from 'components/@extended/Avatar';
import { PopupTransition } from 'components/@extended/Transitions';

// assets
import { InfoCircle, Trash } from 'iconsax-react';

const AlertSponsorStatusChange = ({ title, open, handleClose, name }) => {
    return (
        <Dialog
            open={open}
            onClose={() => handleClose(false)}
            keepMounted
            TransitionComponent={PopupTransition}
            maxWidth="xs"
            aria-labelledby="column-delete-title"
            aria-describedby="column-delete-description"
        >
            <DialogContent sx={{ mt: 2, my: 1 }}>
                <Stack alignItems="center" spacing={3.5}>
                    {/* <Avatar color="warning" sx={{ width: 72, height: 72, fontSize: '1.75rem' }}> */}
                        <InfoCircle variant="Bold" size="60" className='text-orange-500'/>
                    {/* </Avatar> */}
                    <Stack spacing={2}>
                        <Typography variant="h4" align="center">
                            ¿Seguro que desea cambiar el estado del sponsor?
                        </Typography>
                        <Typography align="center">
                            <Typography variant="subtitle1" component="span">
                                {' '}
                                &quot;{name}&quot;{' '}
                            </Typography>
                        </Typography>
                    </Stack>

                    <Stack direction="row" spacing={2} sx={{ width: 1 }}>
                        <Button fullWidth onClick={() => handleClose(false)} color="secondary" variant="outlined">
                            Cancelar
                        </Button>
                        <Button fullWidth color="error" className='bg-orange-500 hover:bg-orange-400' variant="contained" onClick={() => handleClose(true)} autoFocus>
                            Modificar
                        </Button>
                    </Stack>
                </Stack>
            </DialogContent>
        </Dialog>
    );
}

export default AlertSponsorStatusChange